// Location: src/styles/buttonStyles.js
// Date: 20240929
// Author: R Matthews
// Purpose: Styles for button components

import { makeStyles, tokens } from '@fluentui/react-components';
import { rhemlabs } from '../theme';

const transitionProperties = 'background 0.3s ease, color 0.3s ease';

export const useButtonStyles = makeStyles({
  Button: {
    background: `linear-gradient(45deg, ${rhemlabs[110]} 0%, ${rhemlabs[90]} 100%)`,
    color: tokens.colorNeutralBackground1,
    padding: tokens.spacingM,
    border: `1px solid ${rhemlabs[100]}`,
    borderRadius: tokens.borderRadiusMedium,
    cursor: 'pointer',
    transition: transitionProperties,
    '&:hover': {
      background: `linear-gradient(45deg, ${rhemlabs[140]} 0%, ${rhemlabs[110]} 100%)`,
      color: tokens.colorNeutralForeground1Hover,
    },
    '&:focus': {
      outline: `2px solid ${rhemlabs[50]}`,
      outlineOffset: '2px',
    },
    '&:disabled': {
      background: `linear-gradient(45deg, ${rhemlabs[80]} 0%, ${rhemlabs[60]} 100%)`,
      color: tokens.colorNeutralBackgroundDisabled,
      cursor: 'not-allowed',
    },
  },
});